import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';
import UserRoleForm from './UserRoleForm';
import { useSelector } from 'react-redux';

const UserRoleFormPopup = ({
  subject,
  updateHandler,
  permissions,
  role = null,
  brandId = null,
}) => {
  const { userPermissions } = useSelector((state) => state?.user || {});

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const canManageRole =
    userPermissions?.includes('manage_all') ||
    userPermissions?.includes('manage_role');

  const canViewRole =
    userPermissions?.includes('manage_all') ||
    userPermissions?.includes('manage_role') ||
    userPermissions?.includes('view_role');

  return (
    <>
      <Button
        size="sm"
        color="info"
        onClick={toggle}
        className="d-flex align-items-center gap-1"
      >
        <i
          className={`bx ${
            canManageRole
              ? role
                ? 'bx-pen'
                : 'bx-plus'
              : canViewRole
              ? 'bx-eye'
              : ''
          }`}
        ></i>
        {canManageRole
          ? role
            ? ' Edit'
            : ' Create Role'
          : canViewRole
          ? ' View'
          : null}
      </Button>

      <Modal
        size="lg"
        isOpen={isOpen}
        toggle={toggle}
        backdrop="static"
        className="modal-dialog-centered"
      >
        <ModalHeader toggle={toggle} className="border-bottom pb-3">
          {role ? 'Edit Role' : 'Create New Role'}
        </ModalHeader>
        <ModalBody>
          <UserRoleForm
            handleClose={toggle}
            isFromPopup
            subject={subject}
            updateHandler={updateHandler}
            permissions={permissions}
            role={role}
            brandId={brandId}
            canManageRole={canManageRole}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default UserRoleFormPopup;
